module.exports = __webpack_public_path__ + "static/media/tt.0fcd53b8.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/tt.svg
// module id = 2231
// module chunks = 0